import {PayloadAction} from '@reduxjs/toolkit';
import {ForkEffect, call, put, takeLatest} from 'redux-saga/effects';

import {requestLogin} from './loginSaga';

import {requesting, fail} from '../userSlice';
import {signup} from '../userApi';

import * as log from '../../../../logger';

type SignupPayload = {
  name: string;
  email: string;
  password1: string;
  password2: string;
};

type SignupAction = PayloadAction<SignupPayload, 'user/requestSignup'>;

function requestSignup(payload: SignupPayload): SignupAction {
  return {
    type: 'user/requestSignup',
    payload,
  };
}

function* requestSignupSaga({payload}: SignupAction) {
  const {name, email, password1, password2} = payload;

  try {
    yield put(requesting());

    const {token, user} = yield call(signup, name, email, password1, password2);
    const credentials = {
      user,
      organization: user.organization,
    };

    yield put(requestLogin({token, credentials}));
  } catch (error) {
    if (error instanceof Error) {
      yield call(log.exception, error);
    }
    yield put(fail('signupError'));
  }
}

function* watchRequestSignup(): Generator<ForkEffect<void>, void, unknown> {
  yield takeLatest('user/requestSignup', requestSignupSaga);
}

export {requestSignup};

export default watchRequestSignup;
